/** @jsx jsx */
import type { HTMLAttributes } from 'react';
import React from 'react';
import { jsx } from '@balance-web/core';
import { SEGMENTED_CONTROL_DIVIDER } from '@balance-web/theme';

export const Divider = (props: HTMLAttributes<HTMLDivElement>) => {
  const width = 1;

  return (
    <div
      css={{
        alignSelf: 'center',
        backgroundColor: SEGMENTED_CONTROL_DIVIDER,
        height: '1em',
        marginLeft: -width,
        marginRight: -width,
        width: width,
      }}
      {...props}
    />
  );
};
Divider.displayName = 'SegmentedControlDivider';
